var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeorgia = function SvgGeorgia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#georgia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.83 17.391H22.61V.17a20.2 20.2 0 0 0-5.218 0v17.222H.17a20.2 20.2 0 0 0 0 5.218h17.222V39.83a20.2 20.2 0 0 0 5.218 0V22.609H39.83a20.2 20.2 0 0 0 0-5.218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.174 9.565V6.957h-2.61v2.608H6.957v2.609h2.609v2.609h2.609v-2.609h2.608V9.565zM30.435 9.565V6.957h-2.609v2.608h-2.608v2.609h2.608v2.609h2.61v-2.609h2.608V9.565zM12.174 27.826v-2.608h-2.61v2.608H6.957v2.609h2.609v2.609h2.609v-2.61h2.608v-2.608zM30.435 27.826v-2.608h-2.609v2.608h-2.608v2.609h2.608v2.609h2.61v-2.61h2.608v-2.608z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "georgia_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgGeorgia;